module.exports = __webpack_public_path__ + "img/miranda.689dc001.png";